import React, { useMemo, useCallback, useRef, useState, useContext, useEffect } from 'react';
import momentj from 'moment-jalaali';
import { useLocalizedStrings, LocalizationContext } from 'app/localization/Context';
import { DeviceType } from 'app/model/Device';
import { CurrentPageContext, HistoryStackContext } from 'app/home/general-components/HistoryStackContext';

import { ReactComponent as IconLogReport } from 'images/report/general-report.svg';
import { ReactComponent as IconLogFilter } from 'images/report/filter.svg';
import { ReactComponent as IconLogBind } from 'images/bind/log.svg';
import { ReactComponent as IconRoom } from 'images/room/yellow/room.svg';
import { ReactComponent as IconLogUser } from 'images/profile/log.svg';
import { ReactComponent as IconHome } from 'images/setting/home-management.svg';
import { ReactComponent as IconRefresh } from 'images/general/refresh-white.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';

import { ReactComponent as IconHomeWhite } from 'images/setting/home-management-white.svg';
import { ReactComponent as IconLock } from 'images/report/lock.svg';

import { ReactComponent as IconAvatar1 } from 'images/profile/avatar-1.svg';
import { ReactComponent as IconAvatar2 } from 'images/profile/avatar-2.svg';
import { ReactComponent as IconAvatar3 } from 'images/profile/avatar-3.svg';
import { ReactComponent as IconAvatar4 } from 'images/profile/avatar-4.svg';
import { ReactComponent as IconAvatar5 } from 'images/profile/avatar-5.svg';
import { ReactComponent as IconAvatar6 } from 'images/profile/avatar-6.svg';
import { ReactComponent as IconAvatarUnknown } from 'images/profile/avatar-unknown.svg';

import { ReactComponent as IconRedAvatar1 } from 'images/profile/red-avatar-1.svg';
import { ReactComponent as IconRedAvatar2 } from 'images/profile/red-avatar-2.svg';
import { ReactComponent as IconRedAvatar3 } from 'images/profile/red-avatar-3.svg';
import { ReactComponent as IconRedAvatar4 } from 'images/profile/red-avatar-4.svg';
import { ReactComponent as IconRedAvatar5 } from 'images/profile/red-avatar-5.svg';
import { ReactComponent as IconRedAvatar6 } from 'images/profile/red-avatar-6.svg';
import { ReactComponent as IconRedAvatarUnknown } from 'images/profile/red-avatar-unknown.svg';

import { ReactComponent as IconCoolerWhite } from 'images/device/symbol/white/cooler.svg';
import { ReactComponent as IconDoorWhite } from 'images/device/symbol/white/door.svg';
import { ReactComponent as IconElevatorWhite } from 'images/device/symbol/white/elevator.svg';
import { ReactComponent as IconFanWhite } from 'images/device/symbol/white/fan.svg';
import { ReactComponent as IconHomeTheatreWhite } from 'images/device/symbol/white/home-theatre.svg';
import { ReactComponent as IconScenarioSwitchWhite } from 'images/device/symbol/white/scenario-switch.svg';
import { ReactComponent as IconLampWhite } from 'images/device/symbol/white/lamp.svg';
import { ReactComponent as IconRelayWhite } from 'images/device/symbol/white/relay.svg';
import { ReactComponent as IconMotionWhite } from 'images/device/symbol/white/motion.svg';
import { ReactComponent as IconMultipurposeSensorWhite } from 'images/device/symbol/white/multipurpose-sensor.svg';
import { ReactComponent as IconPlugWhite } from 'images/device/symbol/white/plug.svg';
import { ReactComponent as IconProjectorWhite } from 'images/device/symbol/white/projector.svg';
import { ReactComponent as IconRecieverWhite } from 'images/device/symbol/white/reciever.svg';
import { ReactComponent as IconRemoteWhite } from 'images/device/symbol/white/remote.svg';
import { ReactComponent as IconSirenWhite } from 'images/device/symbol/white/siren.svg';
import { ReactComponent as IconDoorbellWhite } from 'images/device/symbol/white/doorbell.svg';
import { ReactComponent as IconSoundbarWhite } from 'images/device/symbol/white/soundbar.svg';
import { ReactComponent as IconSplitWhite } from 'images/device/symbol/white/remote-ac.svg';
import { ReactComponent as IconThermostatWhite } from 'images/device/symbol/white/thermostat.svg';
import { ReactComponent as IconCurtainWhite } from 'images/device/symbol/white/curtain.svg';
import { ReactComponent as IconTVWhite } from 'images/device/symbol/white/tv.svg';
import { ReactComponent as IconAudioControllerWhite } from 'images/device/symbol/white/audio-controller.svg';
import { ReactComponent as IconWCWhite } from 'images/device/symbol/white/wc.svg';

import { ReactComponent as IconDeviceGeneralBlue } from 'images/device/symbol/blue/general.svg';
import { ReactComponent as IconCoolerBlue } from 'images/device/symbol/blue/cooler.svg';
import { ReactComponent as IconDoorBlue } from 'images/device/symbol/blue/door.svg';
import { ReactComponent as IconElevatorBlue } from 'images/device/symbol/blue/elevator.svg';
import { ReactComponent as IconFanBlue } from 'images/device/symbol/blue/fan.svg';
import { ReactComponent as IconHomeTheatreBlue } from 'images/device/symbol/blue/home-theatre.svg';
import { ReactComponent as IconScenarioSwitchBlue } from 'images/device/symbol/blue/scenario-switch.svg';
import { ReactComponent as IconLampBlue } from 'images/device/symbol/blue/lamp.svg';
import { ReactComponent as IconRelayBlue } from 'images/device/symbol/blue/relay.svg';
import { ReactComponent as IconMotionBlue } from 'images/device/symbol/blue/motion.svg';
import { ReactComponent as IconMultipurposeSensorBlue } from 'images/device/symbol/blue/multipurpose-sensor.svg';
import { ReactComponent as IconPlugBlue } from 'images/device/symbol/blue/plug.svg';
import { ReactComponent as IconProjectorBlue } from 'images/device/symbol/blue/projector.svg';
import { ReactComponent as IconRecieverBlue } from 'images/device/symbol/blue/reciever.svg';
import { ReactComponent as IconRemoteBlue } from 'images/device/symbol/blue/remote.svg';
import { ReactComponent as IconSirenBlue } from 'images/device/symbol/blue/siren.svg';
import { ReactComponent as IconDoorbellBlue } from 'images/device/symbol/blue/doorbell.svg';
import { ReactComponent as IconSoundbarBlue } from 'images/device/symbol/blue/soundbar.svg';
import { ReactComponent as IconSplitBlue } from 'images/device/symbol/blue/remote-ac.svg';
import { ReactComponent as IconThermostatBlue } from 'images/device/symbol/blue/thermostat.svg';
import { ReactComponent as IconCurtainBlue } from 'images/device/symbol/blue/curtain.svg';
import { ReactComponent as IconTVBlue } from 'images/device/symbol/blue/tv.svg';
import { ReactComponent as IconAudioControllerBlue } from 'images/device/symbol/blue/audio-controller.svg';
import { ReactComponent as IconWCBlue } from 'images/device/symbol/blue/wc.svg';

import { ReactComponent as IconLogScenario } from 'images/scenario/log.svg';

import PullToRefresh from 'app/home/general-components/PullToRefresh';
import { stringFormat } from 'app/model/BindData';
import { LogSubjectType, clearLogFilterSection, countsInLogFilterSections } from 'app/model/Log';
import { getRoomIcon } from 'app/home/home-components/room-header-tab/RoomHeaderTab';
import { getScenarioIcon } from 'app/model/Scenario';

import './Reports.scss'
import CustomIconBack from 'app/home/home-components/CustomIconBack';


function Reports({ gateway }) {
    const { logs, areLogsFetched, showSecondsInLog, requestMoreLogs, refreshLogs,
        dataFetched, negotiatedProtocol,
        logFilter, setLogFilter } = gateway;

    const l = useContext(LocalizationContext);
    const s = l.strings;

    const hs = useContext(HistoryStackContext);

    const supportLogFilter = negotiatedProtocol.supportLogFilter;
    const { filterIsEmpty, counts } = useMemo(() => countsInLogFilterSections(logFilter), [logFilter]);
    const filterKeys = ["user", "device", "bind", "scenario", "room", "time"];

    return (
        <div className="log-list-container">
            <div className="log-list-header">
                <div className="label">{s.logs}</div>
                <div className="button-group">
                    {supportLogFilter ? null : <div />}
                    <div className="button-with-border" onClick={refreshLogs}>
                        <div className="label">
                            {s.logRefresh.button}
                        </div>
                        <IconRefresh className="icon" />
                    </div>
                    {supportLogFilter ? <div className="button-with-border" onClick={() => {
                        hs.push("/reports/filter");
                    }}>
                        <div className="label">
                            {s.logFilter.button}
                        </div>
                        <IconLogFilter className="icon" />
                        {!filterIsEmpty ? <div className="log-blue-dot" /> : null}
                    </div> : null}
                </div>
            </div>
            {!filterIsEmpty ?
                <div className="log-filtered-by margin-horizontal">
                    <div className="text">{s.logFilter.filteredBy}</div>
                    {filterKeys.map(key => counts[key] > 0 ?
                        <div className="tag" key={"log-report-tag-" + key}>
                            <IconX className="icon" onClick={() => { clearLogFilterSection(logFilter, setLogFilter, key) }} />
                            <div className="text">{s.logFilter[key].someSelectionSmall(l.localizeNumber(counts[key]))}</div>
                        </div> : null)}
                </div> : null
            }

            {/* maybe we can only use areLogsFetched */}
            {(dataFetched && areLogsFetched) ?
                <ReportList
                    logs={logs} showSecondsInLog={showSecondsInLog}
                    requestMoreLogs={requestMoreLogs}
                    refreshLogs={refreshLogs}
                    negotiatedProtocol={negotiatedProtocol}
                    withMarginHorizontal={true} />
                : <div className="log-list margin-horizontal">
                    <div className="empty-list-cell">{s.dataIsLoading}</div>
                </div>}
        </div>
    );
}

export function DetailedReportsOverlayPage({ gateway }) {
    const { logs, areLogsFetched, showSecondsInLog, requestMoreLogs, refreshLogs,
        dataFetched, negotiatedProtocol,
        logFilter, setLogFilter } = gateway;

    const l = useContext(LocalizationContext);
    const s = l.strings;
    const p = useContext(CurrentPageContext);
    // supportLogFilter

    const hs = useContext(HistoryStackContext);

    const supportLogFilter = negotiatedProtocol.supportLogFilter;
    const { filterIsEmpty, counts } = useMemo(() => countsInLogFilterSections(logFilter), [logFilter]);
    const filterKeys = ["user", "device", "bind", "scenario", "room", "time"];

    return (
        <div className="detailed-reports-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />

            <div className="detailed-reports-page-content">
                <div className="nav-button" onClick={p.dismiss} />

                <div className="header-group">
                    <CustomIconBack className="back-icon" />
                    <div />
                    <div className="button-border" onClick={refreshLogs}>
                        <div className="label">
                            {s.logRefresh.button}
                        </div>
                        <IconRefresh className="icon" />
                    </div>
                    {supportLogFilter ?
                        <div className="button-border" onClick={() => { hs.push("/reports/filter-h"); }}>
                            <div className="label">
                                {s.logFilter.button}
                            </div>
                            <IconLogFilter className="icon" />
                            {!filterIsEmpty ? <div className="log-blue-dot" /> : null}
                        </div> : null}
                </div>
                <div className="page-header" style={{ marginBottom: 8 }}>{s.logs}</div>
                {!filterIsEmpty ?
                    <div className="log-filtered-by">
                        <div className="text">{s.logFilter.filteredBy}</div>
                        {filterKeys.map(key => counts[key] > 0 ?
                            <div className="tag" key={"log-report-tag-" + key}>
                                <IconX className="icon" onClick={() => { clearLogFilterSection(logFilter, setLogFilter, key) }} />
                                <div className="text">{s.logFilter[key].someSelectionSmall(l.localizeNumber(counts[key]))}</div>
                            </div> : null)}
                    </div> : null
                }
                {/* maybe we can only use areLogsFetched */}
                {(dataFetched && areLogsFetched) ?
                    <ReportList
                        logs={logs} showSecondsInLog={showSecondsInLog}
                        requestMoreLogs={requestMoreLogs}
                        refreshLogs={refreshLogs}
                        negotiatedProtocol={negotiatedProtocol} />
                    : <div className="log-list">
                        <div className="empty-list-cell">{s.dataIsLoading}</div>
                    </div>}
            </div>
        </div>
    )
}

function getEpochSeconds() {
    return Math.round((new Date()).getTime() / 1000);
}

function ReportList({ logs, showSecondsInLog, requestMoreLogs,
    refreshLogs, negotiatedProtocol, withMarginHorizontal }) {
    const s = useLocalizedStrings();

    const logsElements = useMemo(() => {
        let elements = [];
        for (let i = 0; i < logs.length; i++) {
            const log = logs[i];
            if (negotiatedProtocol.hasNewLogV1 || negotiatedProtocol.hasNewLogV2) {
                elements.push(<NewLogCell key={"log_id_" + String(i)} log={log} showSecondsInLog={showSecondsInLog} />)
            } else {
                elements.push(<LegacyLogCell key={"log_id_" + String(i)} log={log} showSecondsInLog={showSecondsInLog} />)
            }
        }

        elements.push(
            <div style={{ height: 16 - 8 }} key="report-list-padding" />
        );

        return elements;
    }, [logs, negotiatedProtocol.hasNewLogV1, negotiatedProtocol.hasNewLogV2, showSecondsInLog])

    const listRef = useRef();
    const [lastReloadTry, setLastReloadTry] = useState(getEpochSeconds());
    const onScroll = useCallback(() => {
        if (!listRef.current)
            return;

        const scrollHeight = listRef.current.scrollHeight;
        const scrollTop = listRef.current.scrollTop;
        const height = listRef.current.offsetHeight;

        if (scrollTop + height > scrollHeight - 15) {
            if (getEpochSeconds() - lastReloadTry > 3) {
                setLastReloadTry(getEpochSeconds());
                requestMoreLogs();
            }
        }
    }, [lastReloadTry, requestMoreLogs]);

    // React Hook useEffect has an unnecessary dependency: 'listRef.current'.
    // Either exclude it or remove the dependency array. 
    // Mutable values like 'listRef.current' aren't valid dependencies 
    // because mutating them doesn't re-render the component
    useEffect(() => {
        PullToRefresh.init({
            mainElement: listRef.current,
            onRefresh() {
                refreshLogs();
            },
            refreshTimeout: 1000,
            instructionsPullToRefresh: s.logRefresh.instructionsPullToRefresh,
            instructionsReleaseToRefresh: s.logRefresh.instructionsReleaseToRefresh,
            instructionsRefreshing: s.logRefresh.instructionsRefreshing,
            getStyles() {
                return pullToRefreshStyle;
            },
            shouldPullToRefresh() {
                return listRef.current.scrollTop <= 0;
            },
        });
        return () => {
            PullToRefresh.destroyAll();
        };
    });
    // }, [listRef.current, s.logRefresh, refreshLogs]);

    return (
        <div className={"log-list" + (withMarginHorizontal ? " margin-horizontal" : "")} onScroll={onScroll} ref={listRef}>
            {(logs.length > 0) ?
                logsElements
                : <div className="empty-list-cell">{s.noLogs}</div>}
        </div>
    );
}

function NewLogCell({ log, showSecondsInLog }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    const date = useMemo(() => {
        return getLogData(l, log, showSecondsInLog);
    }, [log, l, showSecondsInLog]);

    const isVersion1 = (typeof log.object === 'string' || log.object instanceof String);
    const isVersion2 = !isVersion1;

    const objectName = useMemo(() => {
        if (isVersion1) {
            return log.object;
        } else if (isVersion2) {
            return log.object.name;
        }
        return "";
    }, [log, isVersion1, isVersion2]);

    const logIcon = useMemo(() => {
        if (isVersion1) {
            return getLogIcon({ type: log.log_type, device_type: log.device_type });
        } else if (isVersion2) {
            return getLogIcon({ type: log.object.type, device_type: log.object.device_type, icon: log.object.icon });
        }
        return null;
    }, [log, isVersion1, isVersion2]);

    const subjectIcon = useMemo(() => {
        return getSubjectIcon(log.subject)
    }, [log]);

    const subjectName = useMemo(() => {
        if (log.subject === undefined)
            return undefined;

        switch (log.subject.type) {
            case LogSubjectType.Gateway:
                return s.logSubjectF.hub;
            case LogSubjectType.Bind:
                return stringFormat(s.logSubjectF.bind, log.subject.name);
            case LogSubjectType.Scenario:
                return stringFormat(s.logSubjectF.scenario, log.subject.name);
            case LogSubjectType.User:
            case LogSubjectType.Room:
            case LogSubjectType.Device:
                return stringFormat(s.logSubjectF.general, log.subject.name);
            default: // else
                return "";
        }
    }, [s, log]);

    return (
        <div className="new-log-cell">
            {React.createElement(logIcon, { className: "icon" })}
            <div className="title">{objectName}</div>
            <div className="event">{log.event}{(log.subject !== undefined) ? (
                <div className="subject-container">
                    <div className="name">{subjectName}</div>
                    {(subjectIcon !== undefined) ? React.createElement(subjectIcon, { className: "icon" }) : null}
                </div>
            ) : null}</div>
            <div className="datetime-container">
                <div className="date">{date[0]}</div>
                <div className="time">{date[1]}</div>
            </div>
            {log.redacted ?
                <div className="redacted-notice">
                    <IconLock className="icon" />
                    <div className="text">{s.logIsRedacted}</div>
                </div>
                : null}
        </div>
    )
}

function LegacyLogCell({ log, showSecondsInLog }) {
    const l = useContext(LocalizationContext);

    const date = useMemo(() => {
        return getLogData(l, log, showSecondsInLog);
    }, [log, l, showSecondsInLog]);

    const logIcon = useMemo(() => {
        return getLogIcon({ type: log.log_type, device_type: log.device_type });
    }, [log]);

    return (
        <div className="legacy-log-cell">
            {React.createElement(logIcon, { className: "icon" })}
            <div className="title">
                {l.language === "en" ? log.text_en : log.text_fa}
            </div>
            <div className="datetime-container">
                <div className="date">{date[0]}</div>
                <div className="time">{date[1]}</div>
            </div>
        </div>
    )
}

function getLogData(l, log, showSecondsInLog) {
    let m;
    if (log.timestamp !== undefined) {
        m = momentj.unix(log.timestamp);
    } else {
        m = momentj(log.date, "YYYY-MM-DD HH:mm:ss");
    }

    let timeFormat = "HH:mm";
    if (showSecondsInLog) {
        timeFormat = "HH:mm:ss";
    }
    if (l.language === 'en') {
        momentj.locale("en")
        return [m.format("DD-MMM-YYYY"), m.format(timeFormat)]
    } else if (l.language === 'fa') {
        momentj.locale("fa")
        return [
            l.localizeNumber(m.format("jDD-jMMMM-jYYYY")),
            l.localizeNumber(m.format(timeFormat))
        ]
    } else if (l.language === 'ar') {
        momentj.locale("ar")
        return [
            l.localizeNumber(m.format("DD-MMM-YYYY")),
            l.localizeNumber(m.format(timeFormat))]
    }
}

function getSubjectIcon(subject) {
    if (subject === undefined)
        return undefined;

    switch (subject.type) {
        case LogSubjectType.Gateway:
            return IconHomeWhite;
        case LogSubjectType.User:
            switch (subject.icon) {
                case 0:
                    return IconAvatarUnknown;
                case 1:
                    return IconAvatar1;
                case 2:
                    return IconAvatar2;
                case 3:
                    return IconAvatar3;
                case 4:
                    return IconAvatar4;
                case 5:
                    return IconAvatar5;
                case 6:
                    return IconAvatar6;
                default: // else
                    return undefined;
            }
        case LogSubjectType.Bind:
            return undefined;
        case LogSubjectType.Scenario:
            return getScenarioIcon(subject.icon, true, true);
        case LogSubjectType.Room:
            return getRoomIcon(subject.icon, "white");
        case LogSubjectType.Device:
            switch (subject.device_type) {
                case DeviceType.doorSensor:
                case DeviceType.wifiDoorSensor:
                    return IconDoorWhite;
                case DeviceType.scenarioSwitch:
                    return IconScenarioSwitchWhite;
                case DeviceType.lamp:
                case DeviceType.lampX1TwoWay:
                case DeviceType.dpst:
                case DeviceType.lampX3:
                case DeviceType.lampX4:
                    return IconLampWhite;
                case DeviceType.evaporativeCooler:
                    return IconCoolerWhite;
                case DeviceType.relay4:
                    return IconRelayWhite;
                case DeviceType.motion:
                case DeviceType.wifiMotionSensor:
                    return IconMotionWhite;
                case DeviceType.multipurposeSensor:
                    return IconMultipurposeSensorWhite;
                case DeviceType.wc:
                    return IconWCWhite;
                case DeviceType.curtain1Lamp2:
                case DeviceType.curtain:
                    return IconCurtainWhite;
                case DeviceType.plug:
                case DeviceType.winep:
                    return IconPlugWhite;
                case DeviceType.sedna:
                case DeviceType.hinavaEcoThermostat:
                    return IconThermostatWhite;
                case DeviceType.remote:
                    return IconRemoteWhite;
                case DeviceType.tvRemote:
                    return IconTVWhite;
                case DeviceType.splitRemote:
                    return IconSplitWhite;
                case DeviceType.fanRemote:
                    return IconFanWhite;
                case DeviceType.homeTheatreRemote:
                    return IconHomeTheatreWhite;
                case DeviceType.soundBarRemote:
                    return IconSoundbarWhite;
                case DeviceType.receiverRemote:
                    return IconRecieverWhite;
                case DeviceType.projectorRemote:
                    return IconProjectorWhite;
                case DeviceType.siren:
                    return IconSirenWhite;
                case DeviceType.doorbell:
                    return IconDoorbellWhite;
                case DeviceType.elevator1:
                    return IconElevatorWhite;
                case DeviceType.amplifier:
                    return IconAudioControllerWhite;
                default:
                    return undefined;
            }
        default: // else
            return undefined;
    }
}

// object icon / log icon
function getLogIcon({ type, device_type, icon }) {
    switch (type) {
        case 0: // Gatway
        case 7: // Solo Cloud
            return IconHome;
        case 1: // Device
            switch (device_type) {
                case DeviceType.doorSensor:
                case DeviceType.wifiDoorSensor:
                    return IconDoorBlue;
                case DeviceType.scenarioSwitch:
                    return IconScenarioSwitchBlue;
                case DeviceType.lamp:
                case DeviceType.lampX1TwoWay:
                case DeviceType.dpst:
                case DeviceType.lampX3:
                case DeviceType.lampX4:
                    return IconLampBlue;
                case DeviceType.evaporativeCooler:
                    return IconCoolerBlue;
                case DeviceType.relay4:
                    return IconRelayBlue;
                case DeviceType.motion:
                case DeviceType.wifiMotionSensor:
                    return IconMotionBlue;
                case DeviceType.multipurposeSensor:
                    return IconMultipurposeSensorBlue;
                case DeviceType.wc:
                    return IconWCBlue;
                case DeviceType.curtain1Lamp2:
                case DeviceType.curtain:
                    return IconCurtainBlue;
                case DeviceType.plug:
                case DeviceType.winep:
                    return IconPlugBlue;
                case DeviceType.sedna:
                case DeviceType.hinavaEcoThermostat:
                    return IconThermostatBlue;
                case DeviceType.remote:
                    return IconRemoteBlue;
                case DeviceType.tvRemote:
                    return IconTVBlue;
                case DeviceType.splitRemote:
                    return IconSplitBlue;
                case DeviceType.fanRemote:
                    return IconFanBlue;
                case DeviceType.homeTheatreRemote:
                    return IconHomeTheatreBlue;
                case DeviceType.soundBarRemote:
                    return IconSoundbarBlue;
                case DeviceType.receiverRemote:
                    return IconRecieverBlue;
                case DeviceType.projectorRemote:
                    return IconProjectorBlue;
                case DeviceType.siren:
                    return IconSirenBlue;
                case DeviceType.doorbell:
                    return IconDoorbellBlue;
                case DeviceType.elevator1:
                    return IconElevatorBlue;
                case DeviceType.amplifier:
                    return IconAudioControllerBlue;
                default:
                    return IconDeviceGeneralBlue;
            }
        case 2: // User
            switch (icon) {
                case 0:
                    return IconRedAvatarUnknown;
                case 1:
                    return IconRedAvatar1;
                case 2:
                    return IconRedAvatar2;
                case 3:
                    return IconRedAvatar3;
                case 4:
                    return IconRedAvatar4;
                case 5:
                    return IconRedAvatar5;
                case 6:
                    return IconRedAvatar6;
                default: // else (no icon specified - not in the protocol)
                    return IconLogUser;
            }
        case 3: // Bind
            return IconLogBind;
        case 5: // Scenario
            const _scenarioIcon = getScenarioIcon(icon, false, true);
            if (_scenarioIcon === undefined) {
                return IconLogScenario;
            } else {
                return _scenarioIcon;
            }
        case 6: // Room
            if (icon === undefined)
                return IconRoom;
            else
                return getRoomIcon(icon, "yellow");
        default: // else
            return IconLogReport;
    }
}

const pullToRefreshStyle = `
.__PREFIX__ptr {
  box-shadow: inset 0 -3px 5px rgba(0, 0, 0, 0.12);
  pointer-events: none;
  font-size: 0.85em;
  font-weight: 700;
  top: 0;
  height: 0;
  transition: height 0.3s, min-height 0.3s;
  text-align: center;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  align-content: stretch;
}

.__PREFIX__box {
  padding: 10px;
  flex-basis: 100%;
}

.__PREFIX__pull {
  transition: none;
}

.__PREFIX__text {
  margin-top: .33em;
  color: rgba(255, 255, 255, 0.5);
}

.__PREFIX__icon {
  color: rgba(255, 255, 255, 0.5);
  transition: transform .3s;
}

/*
When at the top of the page, disable vertical overscroll so passive touch
listeners can take over.
*/
.__PREFIX__top {
  touch-action: pan-x pan-down pinch-zoom;
}

.__PREFIX__release .__PREFIX__icon {
  transform: rotate(180deg);
}
`

export default Reports;
